import React from 'react';

import { Interweave as DefaultInterweave } from 'interweave';

import { styled, Box } from '@liscio/ui';

export interface InterweaveProps {
  content: string;
}

const Wrapper = styled(Box)(({ theme }) => ({
  '& img': {
    maxWidth: '90vw',
    height: 'auto',
  },
  '& a': {
    color: theme.palette.common.cyan[500],
  },
}));

/**
 * Decodes HTML entities in a string
 * Example: "&lt;div&gt;" becomes "<div>"
 */
const decodeHtmlEntities = (text: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

export const Interweave: React.FC<InterweaveProps> = ({ content }) => {
  const decodedContent = decodeHtmlEntities(content);

  return (
    <Wrapper>
      <DefaultInterweave content={decodedContent} />
    </Wrapper>
  );
};

export default Interweave;
